import React from 'react';
import Header from '../components/header'; 
import Footer from '../components/footer'; 

const Disclaimer = () => {
  return (
    <div>
      <Header />
      
<div className="section big-55-height over-hide z-bigger">
	
		<div className="parallax parallax-top" style={{ backgroundImage: `url('/img/9.jpeg')` }}></div>
		<div className="dark-over-pages"></div>
	
		<div className="hero-center-section pages">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-12 parallax-fade-top">
						<div className="hero-text">Disclaimer</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	 
	 
	<div className="container">

<div className="card disclaimer-card p-4 p-md-5">

<p>
The information provided on the <strong>Hotel Pahadi Convention</strong> website is for general informational
purposes only. By accessing and using this website, you agree to the terms outlined in this disclaimer.
</p>

<hr/>

<h6>1. Accuracy of Information</h6>
<p>
Hotel Pahadi Convention makes every effort to ensure that the information on this website
is accurate and up to date. However, we do not guarantee the completeness, reliability,
or accuracy of the content. Information such as room rates, services, availability,
and facilities may change without prior notice.
</p>

<hr/>

<h6>2. Booking and Availability</h6>
<p>
Room availability, pricing, and promotional offers displayed on the website are subject
to change and may vary depending on the date, demand, or booking platform.
The hotel reserves the right to modify or cancel bookings in case of pricing errors,
technical issues, or unforeseen circumstances.
</p>

<hr/>

<h6>3. External Links</h6>
<p>
Our website may contain links to third-party websites for booking services,
travel information, or other related resources. Hotel Pahadi Convention does not
control or take responsibility for the content, privacy policies, or practices
of these external websites.
</p>

<hr/>

<h6>4. Limitation of Liability</h6>
<p>
Hotel Pahadi Convention shall not be held liable for any direct, indirect,
incidental, or consequential damages arising from the use of this website
or reliance on any information provided on it. Users access and use the
website at their own risk.
</p>

<hr/>

<h6>5. Website Availability</h6>
<p>
While we strive to ensure that our website is accessible at all times,
Hotel Pahadi Convention does not guarantee uninterrupted access.
The website may be temporarily unavailable due to maintenance,
technical issues, or other factors beyond our control.
</p>

<hr/>

<h6>6. Intellectual Property</h6>
<p>
All content on this website, including text, images, logos, design,
and graphics, is the property of <strong>Hotel Pahadi Convention</strong>
unless otherwise stated. Unauthorized use, reproduction, or distribution
of any content without written permission is prohibited.
</p>

<hr/>

<h6>7. Changes to Disclaimer</h6>
<p>
Hotel Pahadi Convention reserves the right to modify or update this
Disclaimer at any time without prior notice. Users are encouraged
to review this page periodically.
</p>

<hr/>

<h6>8. Contact Information</h6>

<p>
If you have any questions regarding this Disclaimer, please contact:
</p>

<p> <strong>Hotel Pahadi Convention</strong><br></br>
	Hotel Pahadi, Vedvyas, Rourkela, Odisha, India<br></br>
	Email: info@hotelpahadi.com<br></br>
	Phone: +91 9238394006, +91 9692908506 </p>

</div>

</div>
        <Footer />
   
	</div>
	 
  )
}

export default Disclaimer;